/* eslint-disable no-undef */
export function isLocalStorageAvailable() {
    var mod = '__SPLITSOFTWARE__';
    try {
        localStorage.setItem(mod, mod);
        localStorage.removeItem(mod);
        return true;
    }
    catch (e) {
        return false;
    }
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@splitsoftware/splitio-commons/esm/utils/env/isLocalStorageAvailable.js
// module id = 364
// module chunks = 29